function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'react-big-calendar/lib/utils/constants';
import { Icon, Button, Label } from "../..";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Toolbar = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Toolbar, _React$Component);
  function Toolbar() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.navigate = function (action) {
      var onNavigate = _this.props.onNavigate;
      onNavigate(action);
    };
    _this.view = function (view) {
      var onView = _this.props.onView;
      onView(view);
    };
    return _this;
  }
  var _proto = Toolbar.prototype;
  _proto.viewNamesGroup = function viewNamesGroup(messages) {
    var _this2 = this;
    var views = this.props.views;
    var view = this.props;
    var viewNames = views;
    if (viewNames.length > 1) {
      return viewNames.map(function (name) {
        return /*#__PURE__*/_jsx("button", {
          type: "button",
          className: view === name ? 'rbc-active' : '',
          onClick: _this2.view.bind(null, name),
          children: messages[name]
        }, name);
      });
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/_jsx(_Fragment, {});
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props,
      localizer = _this$props.localizer,
      label = _this$props.label,
      buttons = _this$props.buttons;
    var messages = localizer.messages;
    return /*#__PURE__*/_jsxs("div", {
      className: "rbc-toolbar",
      children: [/*#__PURE__*/_jsx("span", {
        className: "rbc-btn-group",
        children: !_.isNil(buttons) ? buttons : ''
      }), /*#__PURE__*/_jsxs("span", {
        className: "rbc-toolbar-label",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return _this3.navigate(navigate.PREVIOUS);
          },
          children: /*#__PURE__*/_jsx(Icon, {
            name: "caret left"
          })
        }), /*#__PURE__*/_jsxs(Label, {
          children: [/*#__PURE__*/_jsx(Icon, {
            name: "calendar outline",
            onClick: function onClick() {
              return _this3.navigate(navigate.TODAY);
            }
          }), ' ', _.capitalize(label)]
        }), /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return _this3.navigate(navigate.NEXT);
          },
          children: /*#__PURE__*/_jsx(Icon, {
            name: "caret right"
          })
        })]
      }), /*#__PURE__*/_jsx("span", {
        className: "rbc-btn-group",
        children: this.viewNamesGroup(messages)
      })]
    });
  };
  return Toolbar;
}(React.Component);
Toolbar.handledProps = ["buttons", "label", "localizer", "onNavigate", "onView", "views"];
Toolbar.propTypes = {
  views: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.node,
  localizer: PropTypes.objectOf(PropTypes.string, PropTypes.number),
  onNavigate: PropTypes.func,
  onView: PropTypes.func,
  buttons: PropTypes.objectOf(PropTypes.string, PropTypes.number)
};
Toolbar.defaultProps = {
  views: [],
  label: null,
  localizer: {},
  onNavigate: null,
  onView: null,
  buttons: null
};
export default Toolbar;